import React from 'react'
import Loader from '../loader'
import { useSuperAdmin } from 'context/super_admin'

function Button({
  type,
  disabled,
  label,
  processing,
  onClick,
  children,
  className,
  ...props
}) {
  const { agency } = useSuperAdmin()
  const btn_bg = agency?.location_config?.button_bg_color
  const btn_text = agency?.location_config?.button_text_color

  return (
    <button
      style={{ 
        backgroundColor: btn_bg || '#F5821F', 
        color: btn_text || '#FFFFFF' 
      }}
      onClick={onClick}
      type={type || 'button'}
      className={`
        ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
        text-white ${className}
        ${btn_bg ? '' : 'bg-[#F5821F]'}
        ${btn_text ? '' : 'text-white'}
        hover:bg-[#e07018]
        active:bg-[#d16a12]
        focus:ring-4 focus:outline-none focus:ring-[#F5821F]/40
        font-medium rounded-lg text-sm px-5 py-2.5 text-center
        transition-all duration-200
      `}
      disabled={disabled || processing}
      {...props}
    >
      {processing ? <Loader /> : label || children}
    </button>
  )
}

export default Button